export default __webpack_public_path__ + "static/media/appraisal-bg-new.191e7f31.png";